import * as React from "react";
import { useRefresh } from "react-admin";
import { Separator } from "../../Components/Separator";
import { DefaultCreatedDateSort, DefaultPerPageSize } from "../../Constants/Constant";
import AbilityCreate from "./AbilityCreate";
import BulkUpload from "./BulkUpload";
import { DataGridColumns } from "./DataGridColumns";
import { useVerifyPermission } from "@airborne/react-admin";
import PoolList from "../../Components/PoolListComponent/PoolListComponent";
export const AbilityControl = props => {
  useVerifyPermission("customroutes", "abilitycontrol.read");
  const refresh = useRefresh();
  return (
    <>
      <BulkUpload refresh={refresh} {...props} />
      <Separator />
      <AbilityCreate refresh={refresh} {...props} />
      <PoolList
        {...props}
        title={"Ability Control List"}
        hasCreate={false}
        exporter={false}
        resource={"abilitycontrols"}
        basePath={"abilitycontrols"}
        hasBulkActions={false}
        sort={DefaultCreatedDateSort}
        perPage={DefaultPerPageSize}
      >
        <DataGridColumns />
      </PoolList>
    </>
  );
};

export default AbilityControl;
